"use client";

import { useEffect } from "react";
import { message } from "antd";
import { useIntl } from "react-intl";
import { subscribeApiConnectionState } from "@/app/shared/api-connection-health";

const API_CONNECTION_MESSAGE_KEY = "api-connection-unavailable";

export default function ApiConnectionNotifier() {
  const intl = useIntl();
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const unsubscribe = subscribeApiConnectionState((nextState) => {
      if (nextState.unavailable) {
        messageApi.open({
          key: API_CONNECTION_MESSAGE_KEY,
          type: "warning",
          content: intl.formatMessage({ id: "api-connection-unavailable" }),
          duration: 0,
        });
        return;
      }
      messageApi.destroy(API_CONNECTION_MESSAGE_KEY);
    });

    return () => {
      unsubscribe();
      messageApi.destroy(API_CONNECTION_MESSAGE_KEY);
    };
  }, [intl, messageApi]);

  return <>{contextHolder}</>;
}
